import "../../style/scss/App.scss";
import { FaRegMeh, FaRegThumbsUp, FaThumbsDown } from "react-icons/fa";

function icon(type) {
  switch (type) {
    case 1:
      return <FaRegThumbsUp className="interestLevelIcon" id="thumbUp" size={1} />;
    case 3:
      return <FaThumbsDown className="interestLevelIcon" id="thumbDown" size={1} />;
    default:
      return <FaRegMeh className="interestLevelIcon" id="meh" size={1} />;
  }
}

export default function EmployerPreferenceListItem({ preferences, onEdit }) {
  const pref = preferences || {};
  const id = pref.ID || pref.id;

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`employer-pref-list-item-${id}`}
        onClick={() => onEdit?.(id)}
      >
        <div className="EmployerPrefs mobilePanel">
          <span className="title">{pref.EmployerName || "Employer preference"}</span>
          <span className="rightText">{icon(pref.PreferenceTypeID)}</span>
        </div>
      </button>
    </li>
  );
}
